import React, { useEffect, useState } from "react";
import { httpClient } from "../../utils/HttpClient";
import { ShortUrlEndpoint } from "../../utils/ApiEndpoint";
import TableTopData from "./_TableTopData";
import { Alert, Col, Row, Stack } from "react-bootstrap";
import PropTypes from "prop-types";

const ShortLinkInfo = ({ ShortLink }) => {
  const [dataReport, setDataReport] = useState("");
  const [countries, setCountries] = useState("");
  function GetInfoFromTtr() {
    httpClient("GET", ShortUrlEndpoint + "reports/detail/" + ShortLink)
      .then(function (response) {
        setDataReport(response.data.data[0]);
        const countriesResp =
          response.data.data[0].countries &&
          response.data.data[0].countries.map((item) => {
            return { name: item.country, value: item.visits };
          });

        setCountries(countriesResp);
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  useEffect(() => {
    GetInfoFromTtr();
  }, []);
  return (
    <>
      <Stack direction="horizontal" gap={2}>
        <h6>Detalle de Visitas</h6>
      </Stack>
      {dataReport && (
        <>
          <Row>
            <Col xs={12}>
              <h2>Datos Geograficos</h2>
              <Alert key={"success"} variant={"success"} className="Notice">
                <b>
                  Se calculan usando como referencia la ip de visita. Se muestra
                  el top 10.
                </b>
              </Alert>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <TableTopData
                data={countries}
                title={"Por Pais  "}
              ></TableTopData>
            </Col>
            {dataReport.regions && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.regions.map((item) => {
                    return { name: item.region, value: item.visits };
                  })}
                  title={"Por Region "}
                ></TableTopData>
              </Col>
            )}
            {dataReport.regions && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.cities.map((item) => {
                    return { name: item.city_name, value: item.visits };
                  })}
                  title={"Por Ciudad "}
                ></TableTopData>
              </Col>
            )}
            {dataReport.regions && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.zipcodes.map((item) => {
                    return { name: item.zip_code, value: item.visits };
                  })}
                  title={"Por Codigo Postal "}
                ></TableTopData>
              </Col>
            )}
          </Row>{" "}
          <Row>
            <hr />
          </Row>
          <Row>
            <Col xs={12}>
              <h2>Datos de Dispositivo</h2>
              <Alert key={"success"} variant={"success"} className="Notice">
                <b>
                  Datos provenientes del user agent del navegador. Se muestra el
                  top 10.
                </b>
              </Alert>
            </Col>
          </Row>
          <Row>
            {" "}
            {dataReport.browsers && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.browsers.map((item) => {
                    return { name: item.browser, value: item.visits };
                  })}
                  title={"Por Navegador"}
                ></TableTopData>
              </Col>
            )}
            {dataReport.browsers && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.devices.map((item) => {
                    return { name: item.device, value: item.visits };
                  })}
                  title={"Por Dispositivo"}
                ></TableTopData>
              </Col>
            )}
            {dataReport.browsers && (
              <Col xs={6}>
                <TableTopData
                  data={dataReport.so.map((item) => {
                    return { name: item.so, value: item.visits };
                  })}
                  title={"Por Sistema Operativo"}
                ></TableTopData>
              </Col>
            )}
          </Row>
        </>
      )}
    </>
  );
};
ShortLinkInfo.propTypes = {
  ShortLink: PropTypes.number.isRequired,
};
export default ShortLinkInfo;
